import Vue from "vue";

function initialState() {
  return {
    LeadSettings: {},
    LeadSourcesLoading : false,
    ShowManageLeadSourceGroupsModal : false,
    leadSourceGroups: []
  };
}

const state = initialState();

const actions = {
  loadLeadSources: function (context, request) {
    if(request.showSpinner)
    context.commit("updateLeadSourcesLoadingIndicator", true);
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/CrmLead/leadsource/get",
        request
      )
        .then(resp => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(err => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          reject(err.response);
        });
    });
  },
  saveLeadSourceSettings: function(context, leadsource) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/CrmLead/leadsource/save",
        leadsource
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  getDealerOEMs: function (context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "GET",
        "/crm/Lookup/oem_info",
        null,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  loadLeadSettings: function(context, request) {
    context.commit("updateLeadSourcesLoadingIndicator", true);
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/CrmLead/leadsettings/get",
        request
      )
        .then(resp => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(err => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          reject(err.response);
        });
    });
  },
  saveLeadSettings: function (context, settings) {
    context.commit("updateLeadSourcesLoadingIndicator", true);
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest("POST", "/api/CrmLead/leadsettings/save", settings)
        .then(resp => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(resp);
        })
        .catch(err => {
          context.commit("updateLeadSourcesLoadingIndicator", false);
          reject(err.response);
        });
    });
  },
  saveLeadSourceGroup: function(context, leadSourceGroup){
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest("POST", "/api/CrmLead/leadsourcegroup/save", leadSourceGroup)
        .then(resp => {
          if (resp.data && resp.data.successful){
            resolve(resp.data);
          } 
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  loadLeadSourceGroups: function(context, request){
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest("POST", "/api/CrmLead/leadsourcegroup/get", request)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit(
              "setLeadSourceGroups",
              resp.data.data
            );
            resolve(resp);
          }
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  loadLeadAutoCloseSettings: function(context, request){
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/CrmLead/autoclosesetting",
        request
      )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp);
          } else reject(resp.data.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  saveLeadAutoCloseSettings: function(context, request){
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "PUT",
        "/api/CrmLead/autoclosesetting",
        request
      )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp);
          } else reject(resp.data.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};

const mutations = {
  updateLeadSourcesLoadingIndicator: function (state, data) {
    state.LeadSourcesLoading = data;
  },
  toggleManageLeadSourceGroupsModal: function(state, data){
    state.ShowManageLeadSourceGroupsModal = data;
  },
  setLeadSourceGroups: function(state, data){
    state.leadSourceGroups = data;
  }
};

const getters = {
  ShowManageLeadSourceGroupsModal: function(){
    return state.ShowManageLeadSourceGroupsModal;
  },
  leadSourceGroups: function(){
    return state.leadSourceGroups;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/LeadSettings.js